import { render } from "./Aboutuspage.vue?vue&type=template&id=e19d73d6"
import script from "./Aboutuspage.vue?vue&type=script&lang=js"
export * from "./Aboutuspage.vue?vue&type=script&lang=js"

import "./Aboutuspage.vue?vue&type=style&index=0&id=e19d73d6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__